import React, {FC} from 'react';

import QuestionCurrency from '../../components/QuestionCurrency';

import styles from './styles.module.scss';

const StepDebt: FC = () => (
  <div className={styles.stepDebt}>
    <QuestionCurrency
      field="outstandingDebt"
      label="Total outstanding debt"
      hintText="Mortgage, credit cards, student loans, auto loans."
    />
    <QuestionCurrency
      field="monthlyDebtPayments"
      label="Monthly debt payments (Optional)"
      hintText="The total you pay toward debt each month."
    />
  </div>
);

export default StepDebt;
